import React from 'react';
import { Icon } from './Icon.js';
export const IconLayoutFooterFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M17,13h-1.5V4.75c0-.689-.561-1.25-1.25-1.25H3.75c-.689,0-1.25,.561-1.25,1.25V13H1V4.75c0-1.517,1.233-2.75,2.75-2.75H14.25c1.517,0,2.75,1.233,2.75,2.75V13Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "1", y: "10", width: "16", height: "6", rx: "2.75", ry: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconLayoutFooterFill18.js.map